export const LOGIN_VERIFICATION_CONTACT_TYPES = ['EMAIL', 'SMS'];
